module.exports = __webpack_public_path__ + "img/red-rupee.2e0c3044.svg";